import { SchemaField } from '../../../../../legacy/objects/generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../../../legacy/objects/generic/serialization/serializable-object-schema';

export class SearchExperienceConfigSchema extends SerializableObjectSchema {
  public static readonly enabled = 'enabled';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters: { [key: string]: import('joi').AnySchema } = {};

    parameters[SearchExperienceConfigSchema.enabled] = SchemaField.boolean(undefined).required();

    return parameters;
  }
}
